const GENERIC_ERROR_MESSAGE = "Erro inesperado. Tente novamente.";

function isUsefulMessage(value: unknown): value is string {
  return typeof value === "string" && value.trim() !== "" && value !== "[object Object]";
}

function readErrorField(error: Record<string, unknown>, field: string) {
  const value = error[field];
  return isUsefulMessage(value) ? value.trim() : null;
}

export function getErrorMessage(error: unknown): string {
  if (isUsefulMessage(error)) return error.trim();

  if (error instanceof Error && isUsefulMessage(error.message)) {
    return error.message.trim();
  }

  if (error && typeof error === "object") {
    const errorObject = error as Record<string, unknown>;
    const extracted =
      readErrorField(errorObject, "message") ||
      readErrorField(errorObject, "details") ||
      readErrorField(errorObject, "hint") ||
      readErrorField(errorObject, "code");

    if (extracted) return extracted;

    try {
      const serialized = JSON.stringify(errorObject);
      if (isUsefulMessage(serialized) && serialized !== "{}") return serialized;
    } catch {
      return GENERIC_ERROR_MESSAGE;
    }
  }

  return GENERIC_ERROR_MESSAGE;
}

export function normalizeError(error: unknown, context?: string): Error {
  const message = getErrorMessage(error);
  const normalized = new Error(context ? `${context}: ${message}` : message);
  if (error !== undefined) {
    (normalized as Error & { cause?: unknown }).cause = error;
  }
  return normalized;
}
